import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { Grid as InavistaGrid, GridActionIconClickEvent, GridConfig, GridRowSelectedEvent } from '@inavista/components/grid';
import { environment } from 'projects/service/src/environments/environment';
import { UserRoles } from 'projects/service/src/app/shared/models/app.model';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import {
  RemoteSearchGridApi, RemoteSearchParam, provideRemoteSearchGrid, remoteSearchRow,
} from 'projects/service/src/app/shared/utils/remote-search-grid-api';
import { PROCEED_ACTION, PROCEED_ACTION_ICONS } from '../config-advanced-search/config-advanced-search.grid.config';
import {
  SERIAL_ADVANCED_SEARCH_URL, SERIAL_COLUMNS, buildSerialAdvancedSearchGridConfig,
} from './config-advanced-search-for-serial-number.grid.config';

const BASE_URL = environment.apiUrl;

// The old grid's content was window.innerHeight - 350 tall, with its toolbar and header above it and the
// "Total Records" bar below. The inavista grid draws all of that inside its own box.
const GRID_CHROME_PX = 124;

@Component({
    selector: 'app-config-advanced-search-for-serial-number',
    templateUrl: './config-advanced-search-for-serial-number.component.html',
    styleUrls: ['./config-advanced-search-for-serial-number.component.scss'],
    // The grid reads the old endpoints through RemoteSearchGridApi (same request, same response).
    providers: [...provideRemoteSearchGrid()],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ConfigAdvancedSearchForSerialNumberComponent implements OnInit {
  isExpanded: boolean = true;
  validationApplied: boolean = false;

  gridConfig: GridConfig = null;
  readonly actionIcons = PROCEED_ACTION_ICONS;
  selectedRowData: any;
  gridHeight: number = window.innerHeight - 350 + GRID_CHROME_PX;

  userRoles;

  model: string = '';
  srNumber: string = '';

  @Input() gridType: any = 'config';

  @Input() serialNumbers;
  @Input() serviceDepartment;
  @Input() offlineOrder: boolean;

  @Output() onClose = new EventEmitter();
  @ViewChild('serviceOrderGrid') serviceOrderGrid: InavistaGrid;
  USER: any;
  private readonly gridApi = inject(RemoteSearchGridApi);

  constructor(
    private commonService: CommonService
  ) {
    this.USER = commonService.USER;
  }

  ngOnInit(): void {
    this.USER = this.commonService.USER;
    this.userRoles = UserRoles;
    const isIsc = this.isIsc();
    // Until a search, no endpoint and no rows (ISC: the old grid had no data source until Search).
    this.gridApi.set(SERIAL_ADVANCED_SEARCH_URL, {
      endpoint: '', columns: SERIAL_COLUMNS, searchFields: SERIAL_COLUMNS.map(([c]) => c), parameters: null,
    });
    this.gridConfig = buildSerialAdvancedSearchGridConfig(
      isIsc ? 'No serial numbers to show. Fill in Model No. and Serial No., then click Search.' : 'No records to display');
    if (!isIsc) {
      this.getSerialNumbers(null, true);
    }
  }

  private isIsc() {
    return this.commonService.USER.role === UserRoles.iscManager || this.commonService.USER.role === UserRoles.IscSupervisor || this.commonService.USER.role === UserRoles.isc;
  }

  validate() {
    this.validationApplied = true;
    return this.model && this.srNumber;
  }

  getSerialNumbers(event, onInit?: boolean) {
    if (this.validate() || onInit) {
      const isIsc = this.isIsc();
      const api = isIsc ? 'EquipmentObject/GetISCSerialNumberSearchView' : 'EquipmentObject/GetSerialNumberSearchView';
      // The Query parameters of the old grid, as the CustomAdaptor sent them: serialSearch is removed and turns
      // Model and Serial Number into 'contains'.
      const parameters: RemoteSearchParam[] = [
        { key: 'company', value: this.USER.company },
        { key: 'serviceDepartment', value: this.serviceDepartment },
        { key: 'offlineOrder', value: this.offlineOrder + '' },
      ];
      if (isIsc) {
        this.model && parameters.push({ key: 'model', value: this.model, oprtr: 'contains' });
        this.srNumber && parameters.push({ key: 'serialNumber', value: this.srNumber, oprtr: 'contains' });
      }
      this.gridApi.set(SERIAL_ADVANCED_SEARCH_URL, {
        endpoint: `${BASE_URL}${api}`, columns: SERIAL_COLUMNS, searchFields: SERIAL_COLUMNS.map(([c]) => c), parameters,
      });
      // On open the grid loads by itself; a Search reloads it.
      if (!onInit) this.serviceOrderGrid?.refresh();
    }
  }

  onActionIconClick(event: GridActionIconClickEvent) {
    if (event.iconKey === PROCEED_ACTION) {
      this.onClose.emit(remoteSearchRow(event.row));
    }
  }

  close() {
    this.onClose.emit();
  }

  rowSelected(event: GridRowSelectedEvent) {
    this.selectedRowData = remoteSearchRow(event.row);
  }

}
